import swal from 'sweetalert';
import print from 'print-js';

